import React, { useState, useEffect, useRef } from 'react';

import profilePic from '../../../../images/auth/avatar icon.webp';
import { login, getMe, logOut } from '../../../../services/userService';

import CornerCloseButton from '../../../shared/CornerCloseButton/CornerCloseButton';
import ErrorMessage from '../../../shared/ErrorMessage/ErrorMessage';
import AuthFormField from '../AuthFormField/AuthFormField';
import Button from '../../buttons/Button/Button';

import './AuthForm.css';

const AuthForm = ({ authOpen, authChange, setUser }) => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const firstInputRef = useRef();

  useEffect(() => {
    const handleKeyDown = (e) =>
      e.key === 'Escape' ? authChange(false) : null;

    firstInputRef.current?.focus();

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [authChange]);

  function handleChange(e) {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
    setError('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await login(credentials);
      const user = await getMe();
      authChange(false);
      setUser(user);
    } catch (err) {
      setError('Log In Failed - Try Again');
      logOut();
      console.log({ 'err.message': err.message });
    }
  }

  return (
    <div className='auth-form-backdrop'>
      <div className='auth-container'>
        <div className='close-form-container'>
          <CornerCloseButton onClick={() => authChange(!authOpen)} />
        </div>
        <div className='auth-content-container'>
          <h1 id='login-title'>LOGIN</h1>
          <img
            className='auth-profile-pic'
            src={profilePic}
            alt='proevoltion-profile-pic'
          />
          <ErrorMessage>{error}</ErrorMessage>
          <form id='form-container' onSubmit={handleSubmit}>
            <AuthFormField
              type='email'
              name='email'
              label='Email'
              value={credentials.email}
              onChange={handleChange}
              autoComplete='on'
              ref={firstInputRef}
              required
            />
            <AuthFormField
              type='password'
              name='password'
              label='Password'
              value={credentials.password}
              onChange={handleChange}
              required
            />
            <Button fixedWidth={false} type='submit' className='auth-button'>
              Login
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
